import {
     Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, OnInit, OnChanges, ElementRef,
    } from '@angular/core';
import { UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-header-app-subtitle',
    templateUrl: './header-app-subtitle.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiHeaderAppSubtitleComponent implements OnInit, OnChanges {

    @HostBinding('class') string = 'eui-header-app-subtitle';

    constructor(
        public asService: UxAppShellService,
        private elRef: ElementRef,
    ) {
    }

    ngOnInit() {
        this.asService.setState({
            ...this.asService.state,
            appSubTitle: this.elRef.nativeElement.innerHTML,
        });
    }

    ngOnChanges() {
        this.asService.setState({
            ...this.asService.state,
            appSubTitle: this.elRef.nativeElement.innerHTML,
        });
    }
}
